import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UiNdmsModule } from '../../../../shared/ui-ndms/ui-ndms.module';
import { JpatsNavComponent } from "../../components/jpats-nav/jpats-nav.component";
import { HasPermissionDirective } from "../core-jpats/has-permission.directive"
import {ButtonChangeLocationComponent} from "../../components/button-change-location/button-change-location.component";
import {UnauthorizedComponent} from "../../components/unauthorized/unauthorized.component";

@NgModule({
  imports: [
    CommonModule,
    UiNdmsModule
  ],
  declarations: [
    JpatsNavComponent,
    ButtonChangeLocationComponent,
    UnauthorizedComponent,
    HasPermissionDirective
  ],
  exports: [
    UiNdmsModule,
    JpatsNavComponent,
    ButtonChangeLocationComponent,
    UnauthorizedComponent,
    HasPermissionDirective
  ]
})
export class UiJpatsModule { }
